<template lang="pug">
  .kontakt
    h1(v-html='headline')
    .body
      //- p(v-for='paragraph in body', v-html='paragraph')
      //- a.cta(:href='"mailto:" + email') Jetzt Anfragen
      .address
        //- h2(v-html='body.address.name')
        .contact-logo(v-html='body.address.logo')
        p(v-html='body.address.street')
      .contact
        a(:href='"tel:" + body.contact.tel.raw') {{body.contact.tel.nice}}
        br
        a(:href='"mailto:" + body.contact.email') {{body.contact.email}}
      //- .legal
      //-   p(v-for='line in body.legal') {{line}}
      .credits
        p.gold design & code by
        a(href='http://www.atelierkarasinski.com', target='blank') Atelier Karasinski
        br
        a(href='http://www.maxschulmeister.com', target='blank') Max Schulmeister

    .clear
</template>

<script>
  export default {
    data () {
      return {
        title: 'Kontakt',
        indicator: require('@/assets/img/donauhof-contact.svg'),
        // image: require('@/assets/img/donauhof-co-working-image.jpg'),
        image: {
          src: 'data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAAQAAAAFAQMAAABYY9+YAAAAA1BMVEXt9/YJY156AAAACklEQVQI12OAAwAACgABaQY5MgAAAABJRU5ErkJggg==',
          center: {
            lat: 48.231665,
            lng: 16.394992
          },
          marker: {
            fontFamily: 'GT Haptik',
            fontWeight: 'bold',
            text: '0',
            color: 'rgba(218,149, 51, 1)',
            fontSize: '32px'
          },
          options: {
            styles: [{"featureType":"all","elementType":"labels.text.fill","stylers":[{"saturation":36},{"color":"#333333"},{"lightness":40}]},{"featureType":"all","elementType":"labels.text.stroke","stylers":[{"visibility":"on"},{"color":"#ffffff"},{"lightness":16}]},{"featureType":"all","elementType":"labels.icon","stylers":[{"visibility":"off"}]},{"featureType":"administrative","elementType":"geometry.fill","stylers":[{"color":"#fdfaf5"},{"lightness":"0"},{"gamma":"1"}]},{"featureType":"administrative","elementType":"geometry.stroke","stylers":[{"color":"#fdfaf5"},{"lightness":"0"},{"weight":1.2},{"gamma":"1"}]},{"featureType":"landscape","elementType":"geometry","stylers":[{"color":"#fdfaf5"},{"lightness":"0"},{"gamma":"1.00"}]},{"featureType":"poi","elementType":"geometry","stylers":[{"color":"#da9533"},{"lightness":"75"},{"gamma":"1.00"}]},{"featureType":"poi.park","elementType":"geometry","stylers":[{"color":"#da9533"},{"lightness":"75"},{"gamma":"1.00"},{"saturation":"0"},{"weight":"1"}]},{"featureType":"road.highway","elementType":"geometry.fill","stylers":[{"color":"#333333"},{"lightness":"95"},{"gamma":"1"}]},{"featureType":"road.highway","elementType":"geometry.stroke","stylers":[{"color":"#333333"},{"lightness":"95"},{"weight":0.2}]},{"featureType":"road.arterial","elementType":"geometry","stylers":[{"color":"#333333"},{"lightness":"95"},{"gamma":"1"}]},{"featureType":"road.local","elementType":"geometry","stylers":[{"color":"#333333"},{"lightness":"95"},{"gamma":"1"}]},{"featureType":"transit","elementType":"geometry","stylers":[{"color":"#da9533"},{"lightness":"50"}]},{"featureType":"water","elementType":"geometry","stylers":[{"color":"#edf7f6"},{"lightness":"0"},{"gamma":"1"}]}],
            // backgroundColor: '#fdfaf5',
            backgroundColor: '#edf7f6',
            zoomControl: true,
            mapTypeControl: false,
            scaleControl: false,
            streetViewControl: false,
            rotateControl: false,
            scrollwheel: true,
            fullscreenControl: false
          }
        },
        background: {
          rotate: 130,
          scale: {
            x: 2,
            y: 2
          },
          translate: {
            x: '-50%',
            y: '-450%'
          }
        },
        headline: 'Die Donau fließt durch viele Städte – vor allem aber durch Wien und zu uns.',
        body: {
          address: {
            name: 'Donauhof Wien',
            logo: require('@/assets/img/donauhof-name.svg'),
            street: 'Engerthstraße 141,<br>A-1020 Wien'
          },
          contact: {
            email: 'office@donauhofwien.at',
            tel: {
              raw: '00436769731617',
              nice: '+43 676 973 16 17'
            }
          },
          legal: [
            'Firmenbuchnummer: FN 293622 y',
            'Handelsgericht Wien',
            'Ust-ID: ATU63400947'
          ]
        }
      }
    },
    head () {
      return {
        title: this.title
      }
    }
    // created () {
    //   this.$parent.currentIndicator = this.indicator
    //   this.$parent.currentImage = this.image
    // }
  }
</script>

<style lang="scss">
  @import "~utils";
  .kontakt {
    .body {
      margin-top: $gutter*2;
      > div {
        margin-bottom: 1.5rem;
        .contact-logo {
          // max-width: 12rem;
          // display: inline-block;
          margin-bottom: $gutter;
          svg {
            width: 12.75rem;
            height: 1.125rem;
          }
        }
        a {
          @include serif;
          position: relative;
          &:after {
            @include pseudo;
            height: 2px;
            background: $blue;
            bottom: -.125rem;
            top: auto;
            transition: transform .25s $easeOut;
          }
          @include desktop {
            &:hover:after {
              transform: translate3d(0, .0625rem, 0);
              transition: transform .25s $easeOut;
              transition-delay: .125s;
            }
          }
        }
        p {
          margin-bottom: 0 !important;
        }
      }
    }
  }
</style>



// WEBPACK FOOTER //
// Kontakt.vue?3f143d90